import React, { useState } from "react";
import {
  fieldsDetail,
  isFormAtom,
} from "../../components/admin/DndTemplate/DndAtom/DndTemplateAtom";
import { useAtom } from "jotai";
// import { Form } from "semantic-ui-react";
import { DroppableContainer } from "../../components/admin/DndTemplate/helper/DndHelper";
import CuModal from "../../common_component/component/CuModal";
import FormComponent from "./FormComponent";
import { MdDelete } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { IoMdEye } from "react-icons/io";
import Confirmation from "./Confirmation";
import { useSecureDeleteItem } from "../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { clinicAtom } from "../../_helper/constant/constant-atom";
const DropBox = ({ selectedValue, predefinedFields }) => {
  const [items, setItems] = useState([]);
  //   const [selectedOption, setSelectedOption] = useState(false);
  const [isForm, setIsForm] = useAtom(isFormAtom);
  const [fields, setFields] = useAtom(fieldsDetail);
  const [clinic] = useAtom(clinicAtom);

  const handleDropdownChange = (e, data) => {
    const selectedValue = data.value;
    // setSelectedOption(true);
    setItems([...items, selectedValue]);
  };

  const fieldClickHandler = (field) => {
    setIsForm({ isForm: true, id: field.id, isEdit: true });
  };

  const deleteClickHandler = (field) => {
    setIsForm({ isForm: true, data: field, isDelete: true });
  };

  // //("fields-------", JSON.stringify(fields, null, 2));
  //("isForm--------", isForm);
  const onClose = () => {
    setIsForm({ isForm: false, id: "", isDelete: false });
  };

  const deleteMutation = useSecureDeleteItem(ApiEndPoint.CUSTOM_FIELDS);

  const handleDelete = () => {
    const payload = {
      id: isForm?.data?.id,
      backend: "True",
      action: "delCustomFields",
      clinic_id: clinic?.id,
    };

    //("payload---------", payload, isForm?.data?.id);
    deleteMutation.mutate(payload, {
      onSuccess: (data) => {
        setIsForm({ isForm: false, id: "", isDelete: false });
      },
      onError: (error) => {
        //("error-------", error);
      },
    });
  };

  const predefinedClickHandler = (field) => {
    setIsForm({ isForm: true, data: field, isPredifined: true });
  };

  return (
    <div>
      <DroppableContainer droppableId="dest">
        <div className="w-full min-h-[450.89px]">
          <div className="w-full h-full">
            <form>
              {selectedValue &&
                predefinedFields.map((field) => {
                  return (
                    <div className="flex items-center gap-4 mt-2">
                      <div
                        className="border w-[320px] h-[48px] flex px-4 items-center"
                        key={field?.id}
                      >
                        {field.name}
                      </div>
                      <IoMdEye
                        size={20}
                        className="cursor-pointer"
                        onClick={() => predefinedClickHandler(field)}
                      />
                    </div>
                  );
                })}
              {fields.map((field) => (
                <>
                  {field?.module_name === selectedValue ? (
                    <div
                      key={field.id}
                      className="flex items-center gap-4 mt-2"
                    >
                      {/* <label>
                        {field.display_name}
                        <Icon
                          name="write"
                          style={{ padding: "3px", cursor: "pointer" }}
                          onClick={() => fieldClickHandler(field)}
                        />
                      </label>
                      {getInputField(field)} */}
                      <div className="border w-[320px] h-[48px] flex px-4 items-center rounded">
                        {field.display_name}
                      </div>
                      {/* <Icon
                        name="write"
                        style={{ padding: "3px", cursor: "pointer" }}
                        onClick={() => fieldClickHandler(field)}
                      /> */}
                      <MdEdit
                        size={20}
                        className="cursor-pointer"
                        onClick={() => fieldClickHandler(field)}
                      />
                      <MdDelete
                        size={20}
                        onClick={() => deleteClickHandler(field)}
                        className="cursor-pointer"
                      />
                    </div>
                  ) : (
                    <div className="border">{field.display_name}</div>
                  )}
                </>
              ))}
            </form>
          </div>
        </div>
      </DroppableContainer>

      {isForm.isDelete && isForm.isForm && (
        <CuModal
          closeModal={() =>
            setIsForm({ isForm: false, id: "", isDelete: false })
          }
        >
          <Confirmation
            heading={`Delete ${isForm?.data?.name}`}
            onCancel={onClose}
            onClick={handleDelete}
            loading={deleteMutation.isLoading}
          />
        </CuModal>
      )}

      {(isForm.isEdit || isForm.isOpen || isForm?.isPredifined) && (
        <CuModal
          closeModal={() =>
            setIsForm({
              isForm: false,
              id: "",
              data: "",
              isEdit: false,
              isOpen: false,
              isPredifined: false,
            })
          }
        >
          <FormComponent selectedValue={selectedValue} />
        </CuModal>
      )}
    </div>
  );
};

export default DropBox;
